<script>
  export default {
    name: 'MTableCommon',
    methods: {
      getComputedColumns (providedColumns, isNestedTable = false) {
        const columns = [];

        const checkBoxColumn = this.getSelectColumnParams(isNestedTable);
        if (checkBoxColumn) {
          columns.push(checkBoxColumn);
        }
        const dropdownTriggerColumn = this.getDropdownTriggerColumnParams(isNestedTable);
        if (dropdownTriggerColumn) {
          columns.push(dropdownTriggerColumn);
        }
        const nestedExpandColumn = this.getNestedExpandTriggerColumnParams(isNestedTable);
        if (nestedExpandColumn) {
          columns.push(nestedExpandColumn);
        }
        return [...columns, ...providedColumns];
      }
    }
  };
</script>
